export default __webpack_public_path__ + "static/media/nagykep.3ce702ae.jpg";